import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const edit = listeners["edit"] || function () { };
  const del = listeners["del"] || function () { };
  const state = listeners["state"] || function () { };


  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    if (vo.row.onlineStatus == 1) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "homepage:update;homepage:info"]);
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => { },
        "homepage:delete"
      ])
      dealConf.push([
        "icon-down",
        "下线",
        () => { state(vo.row) },
        "homepage:online"
      ]);
    } else {
      dealConf.push(["icon-edit", "编辑", () => { edit(vo.row) }, "homepage:update;homepage:info"])
      dealConf.push(["icon-delete", "删除", () => { del(vo.row) }, "homepage:delete"])
      dealConf.push([
        "icon-up",
        "上线",
        () => { state(vo.row) },
        "homepage:online"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const Img = ({ props: { vo } }) => {
    return (
      <div >
        <el-image 
          style="width: 160px; height: 90px; cursor: pointer" 
          src={vo.row.pageUrl} 
          fit={'contain'} 
          lazy
          preview-src-list={[vo.row.pageUrl]}
        ></el-image>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "图片预览",
      minWidth: "140",
      render: vo => <Img vo={vo} />
    },
    {
      label: "标题",
      prop: "pageTitle",
      minWidth: "160"
    },
    {
      label: "是否默认",
      prop: "isDefaultName",
      minWidth: "100"
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "100"
    },
    {
      label: "创建者",
      prop: "createUserName",
      minWidth: "160"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "160"
    },
    {
      label: "生效时间",
      prop: "startAndEndTime",
      minWidth: "170"
    },
    {
      label: "操作",
      minWidth: "150",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
}

export default Table;